export const lawInTheDigitalEconomyConst = {
  path: "/single-programs/law-in-the-digital-economy",
  title: "ФАКУЛЬТЕТ ПРАВА — ПРАВО В ЦИФРОВОЙ ЭКОНОМИКЕ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом: </strong>бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения: </strong>очно или дистанционно
      </p>
      <p>
        <strong>Форма связи: </strong>Получить консультацию приемной комиссии
      </p>
      <h2>Право в цифровой экономике — регулирование будущего</h2>
      <p>
        Цифровая трансформация требует новых юридических подходов и экспертизы. Эта программа объединяет право, технологии и инновации.
        Студенты изучают правовое регулирование IT-платформ, защиту данных, интеллектуальную собственность, финтех и блокчейн.
      </p>
      <p>
        Программа подойдет тем, кто хочет работать на передовой цифрового права — в стартапах, технологических гигантах, международных
        юридических фирмах и консалтинговых компаниях.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Цифровое право и регулирование онлайн-платформ</li>
        <li>Защита персональных данных (GDPR и др.)</li>
        <li>Право интеллектуальной собственности в IT</li>
        <li>Блокчейн, криптовалюты и смарт-контракты</li>
        <li>Электронная коммерция и цифровые сделки</li>
        <li>Финтех и правовые аспекты цифровых финансов</li>
        <li>Кибербезопасность и правовая ответственность</li>
        <li>Комплаенс и цифровая правовая этика</li>
      </ul>
      <p>
        Обучение включает работу с реальными кейсами, симуляции судебных процессов, консультации с практикующими IT-юристами и участие в
        цифровых проектах.
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Юрист в IT-компании или технологическом стартапе</li>
        <li>Консультант по цифровому праву и e-commerce</li>
        <li>Специалист по защите данных и приватности (Data Protection Officer)</li>
        <li>Юрисконсульт по интеллектуальной собственности</li>
        <li>Эксперт по правовому сопровождению цифровых продуктов и услуг</li>
      </ul>
      <h2>Зарплата в Европе:</h2>
      <p>
        от <strong>€55,000 до €110,000 в год</strong> — особенно в сфере финтеха, кибербезопасности и IT-консалтинга.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом с признанием в сфере digital-права</li>
        <li>Обучение на русском или английском языке</li>
        <li>Гибкий формат: очно или дистанционно</li>
        <li>Программа, соответствующая вызовам цифровой среды</li>
        <li>Стажировки в IT-компаниях и международных структурах</li>
        <li>Поддержка карьерного роста и сопровождение студентов</li>
      </ul>
      <p>Право в цифровой экономике — это профессия, где вы регулируете технологии, меняющие мир.</p>
      <h2>Как поступить?</h2>
      <p>Приёмная комиссия сопровождает вас на всех этапах: от подачи заявки до начала обучения.</p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра / магистра
    Формы обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии
    Право в цифровой экономике — регулирование будущего
    Цифровая трансформация требует новых юридических подходов и экспертизы. Эта программа объединяет право, технологии и инновации. Студенты изучают правовое регулирование IT-платформ, защиту данных, интеллектуальную собственность, финтех и блокчейн.
    Программа подойдет тем, кто хочет работать на передовой цифрового права — в стартапах, технологических гигантах, международных юридических фирмах и консалтинговых компаниях.
    Что вы будете изучать?
    • Цифровое право и регулирование онлайн-платформ
    • Защита персональных данных (GDPR и др.)
    • Право интеллектуальной собственности в IT
    • Блокчейн, криптовалюты и смарт-контракты
    • Электронная коммерция и цифровые сделки
    • Финтех и правовые аспекты цифровых финансов
    • Кибербезопасность и правовая ответственность
    • Комплаенс и цифровая правовая этика
    Обучение включает работу с реальными кейсами, симуляции судебных процессов, консультации с практикующими IT-юристами и участие в цифровых проектах.
    Кем можно работать после окончания?
    • Юрист в IT-компании или технологическом стартапе
    • Консультант по цифровому праву и e-commerce
    • Специалист по защите данных и приватности (Data Protection Officer)
    • Юрисконсульт по интеллектуальной собственности
    • Эксперт по правовому сопровождению цифровых продуктов и услуг
    Зарплата в Европе: от €55,000 до €110,000 в год — особенно в сфере финтеха, кибербезопасности и IT-консалтинга.
    Почему выбирают нас?
    • Европейский диплом с признанием в сфере digital-права
    • Обучение на русском или английском языке
    • Гибкий формат: очно или дистанционно
    • Программа, соответствующая вызовам цифровой среды
    • Стажировки в IT-компаниях и международных структурах
    • Поддержка карьерного роста и сопровождение студентов
    Право в цифровой экономике — это профессия, где вы регулируете технологии, меняющие мир.
    Как поступить? 
    Приёмная комиссия сопровождает вас на всех этапах: от подачи заявки до начала обучения.
  `,
};
